import { useEndpointFetch } from '../../../../../global/network/useEndpointFetch';
import { CertificateAsset } from './certificate-model';

export const useCertificateAssetUpload = () => {
  const uploadFetch = useEndpointFetch<{ kind: 'signature' | 'background'; file: File }, CertificateAsset>(
    '/vm/admin-console/certificate-template/asset',
    { formData: true }
  );

  const upload = async (kind: 'signature' | 'background', file: File): Promise<CertificateAsset> => {
    const response = await uploadFetch.run({ kind, file });
    if (!response.ok) throw new Error(response.data?.message || 'Unable to upload image');
    return response.data.data;
  };

  return { upload, uploading: uploadFetch.isLoading };
};
